// extracted by mini-css-extract-plugin
module.exports = {"red":"sendBack_red_3yYZa"};